import { createAsyncThunk } from '@reduxjs/toolkit';
import { getWhatsAppChatMessages } from 'services/whatsAppMessaging';
import { IWhatsAppMessage } from 'services/whatsAppMessaging/types';

export const ThunkGetWhatsAppChatMessages = createAsyncThunk<IWhatsAppMessage[], string>(
  'whatsAppMessaging/getMessages',
  async chatId => {
    const { data } = await getWhatsAppChatMessages(chatId);
    return data ?? [];
  },
);
